import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = ({ name = "Brian Oller" }) => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 2,
        borderTop: 1,
        borderColor: "divider",
        textAlign: "center"
      }}
    >
      <Typography variant="body2" color="text.secondary">
        &copy; {new Date().getFullYear()} {name}
      </Typography>
    </Box>
  );
};

export default Footer;
